import React, { useState } from 'react';
import { fc } from '../../utils';

export function SubscriptionAuditCard({ subscriptions }) {
  const [expanded, setExpanded] = useState(false);

  const subs = subscriptions || [];
  if (subs.length === 0) return null;

  const monthly = subs.filter((s) => s.cycle !== 'annual');
  const annual = subs.filter((s) => s.cycle === 'annual');
  const monthlyTotal = monthly.reduce((s, x) => s + (x.amt || 0), 0);
  const annualMonthly = annual.reduce((s, x) => s + (x.amt || 0), 0) / 12;
  const totalMonthly = monthlyTotal + annualMonthly;
  const annualCost = totalMonthly * 12;

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <button
        onClick={() => setExpanded((e) => !e)}
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', background: 'none', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit' }}
      >
        <div className="st" style={{ marginBottom: 0 }}>🔄 Subscription Audit</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 900, color: 'var(--pnk)' }}>{fc(totalMonthly)}/mo</span>
          <span style={{ fontSize: 11, color: 'var(--mut)' }}>{expanded ? '▲' : '▼'}</span>
        </div>
      </button>
      <div style={{ fontSize: 10, color: 'var(--mut)', marginTop: 4 }}>
        {subs.length} subscription{subs.length !== 1 ? 's' : ''} · {fc(annualCost)}/year
      </div>
      {expanded && (
        <div style={{ marginTop: 10 }}>
          {subs.map((sub) => (
            <div key={sub.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--bdr)' }}>
              <div className="dot" style={{ background: sub.col || 'var(--pnk)', flexShrink: 0 }} />
              <div style={{ flex: 1, fontSize: 12, fontWeight: 600 }}>{sub.name}</div>
              <div style={{ fontSize: 10, color: 'var(--mut)' }}>{sub.cycle === 'annual' ? 'annual' : 'monthly'}</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--pnk)' }}>{fc(sub.amt)}</div>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 12, fontWeight: 700 }}>
            <span style={{ color: 'var(--mut)' }}>Total per year</span>
            <span style={{ color: 'var(--pnk)' }}>{fc(annualCost)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
